import { LBButton } from '@linearb/buzz';
import { Tooltip } from '@material-ui/core';
import Icon from 'components/base/Icon';
import { StyledCell } from 'components/base/Table/Table.styles';

const StateCell = ({ token }) => {
  const isOK = token?.state === 'ok';
  const StateIcon = isOK ? (
    <Icon name='Check' color='pastelGreen' size='medium' />
  ) : (
    <Icon name='Close' color='radicalRed' size='medium' />
  );
  const failingReason = token?.failing_reason?.description || (
    <>
      This token is inactive or invalid.
      <br /> It may have expired or been revoked
    </>
  );
  const isPrimary = token?.is_primary;

  return (
    <StyledCell>
      <Tooltip title={failingReason} disableHoverListener={isOK}>
        {StateIcon}
      </Tooltip>
      {isPrimary && (
        <Tooltip
          title={
            <>
              This is your default token for discovering repositories.
              <br />
              Make sure it has the correct org permissions.
            </>
          }
        >
          <LBButton size='sm' className='ml-5 cursor-default'>
            Primary
          </LBButton>
        </Tooltip>
      )}
    </StyledCell>
  );
};

export default StateCell;
